import styled from 'styled-components';

export default styled.div`
  > div {
    display: flex;
    flex-direction: column;
    gap: 4px 0;
  }
`;
